module.exports = __webpack_public_path__ + "static/media/cr.8f9e3dcc.svg";